export const words = {
    "intro1-0": {
        "EN": "Your",
        "FR": "Ton",
        "ES": "Tu"
    },
    "intro1-1": {
        "EN": "experience as an",
        "FR": "expérience en tant que",
        "ES": "experiencia, como"
    },
    "intro1-2": {
        "EN": "integral part",
        "FR": "partie intégrante",
        "ES": "parte integral"
    },
    "intro1-3": {
        "EN": "of this culture",
        "FR": "de cette culture",
        "ES": "de esta cultura"
    },
    "intro1-4": {
        "EN": "matters",
        "FR": "compte",
        "ES": "nos importa"
    },
    "intro2-0": {
        "EN": "Your",
        "FR": "T'es",
        "ES": "Tu"
    },
    "intro2-1": {
        "EN": "responses",
        "FR": "réponses",
        "ES": "respuestas"
    },
    "intro2-2": {
        "EN": "from this survey",
        "FR": "de cette enquête",
        "ES": "en esta encuesta"
    },
    "intro2-3": {
        "EN": "will be used to create",
        "FR": "seront utilisées pour créer",
        "ES": "se utilizarán para crear"
    },
    "intro2-4": {
        "EN": "real change.",
        "FR": "un vrai changement.",
        "ES": "un cambio real."
    },
    "intro3-0": {
        "EN": "Your",
        "FR": "T'es",
        "ES": "Tu"
    },
    "intro3-1": {
        "EN": "responses",
        "FR": "réponses",
        "ES": "respuestas"
    },
    "intro3-2": {
        "EN": "are anonymous",
        "FR": "sont anonymes",
        "ES": "son anónimas"
    },
    "intro3-3": {
        "EN": " and will never be ",
        "FR": " et ne seront jamais ",
        "ES": " y nunca serán "
    },
    "intro3-4": {
        "EN": "attached to",
        "FR": "attachées à",
        "ES": "vinculadas a"
    },
    "intro3-5": {
        "EN": "your identity.",
        "FR": "votre identité.",
        "ES": "tu identidad."
    },
    "intro4-0": {
        "EN": "Do you agree with your personal data being processed as described below and in our privacy statement?",
        "FR": "Êtes-vous d'accord pour que vos données personnelles soient traitées comme décrit ci-dessus et dans notre déclaration de confidentialité ?",
        "ES": "¿Estás de acuerdo con que tus datos personales sean procesados como se describe abajo y en nuestra declaración de privacidad?"
    },
    "intro4-1": {
        "EN": "Privacy Agreement",
        "FR": "Accord de confidentialité",
        "ES": "Acuerdo de Privacidad"
    },
    "intro5-0": {
        "EN": "Are you over the age of 16?",
        "FR": "Avez-vous plus de 16 ans ?",
        "ES": "Acuerdo de Privacidad"
    },
    "intro7-0": {
        "EN":"Are you 19 years old or older?",
        "FR":"Avez-vous 19 ans ou plus?",
        "ES":"¿Tienes 19 años o más?"
    },
    "back": {
        "EN": "Back",
        "FR": "Retour",
        "ES": "Atrás"
    },
    "Start": {
        "EN": "Start",
        "FR": "Démarrer",
        "ES": "Empezar"
    },
    "Next": {
        "EN": "Next",
        "FR": "Suivant",
        "ES": "Siguiente"
    },
    "I agree": {
        "EN": "I agree",
        "FR": "Je suis d'accord",
        "ES": "Estoy de acuerdo"
    },
    "Submit": {
        "EN": "Submit",
        "FR": "Soumettre",
        "ES": "Enviar"
    },
    "of": {
        "EN": "of",
        "FR": "de",
        "ES": "de"
    },
    "category": {
        "EN": "Categorical Question",
        "FR": "Question catégorique",
        "ES": "Pregunta Categórica"
    },
    "Culture Question": {
        "EN": "Culture Question",
        "FR": "Question Culturelle",
        "ES": "Pregunta Cultural"
    },
    "qualifier": {
        "EN": "In this culture...",
        "FR": "Dans cette culture...",
        "ES": "En esta cultura..."
    },
    "Strongly Disagree": {
        "EN": "Strongly Disagree",
        "FR": "Fortement en désaccord",
        "ES": "Muy en desacuerdo"
    },
    "Strongly Agree": {
        "EN": "Strongly Agree",
        "FR": "Fortement d'accord",
        "ES": "Totalmente de acuerdo"
    },
    "Neutral": {
        "EN": "Neutral",
        "FR": "Neutre",
        "ES": "Neutral"
    },
    "min_feedback": {
        "EN": "We noticed you scored the following statement amongst lowest overall",
        "FR": "Nous avons remarqué que vous avez obtenu le score le plus bas pour l'énoncé suivant",
        "ES": "Hemos notado que calificaste la siguiente afirmación entre las más bajas en general"
    },
    "max_feedback": {
        "EN": "We noticed you scored the following statement amongst highest overall",
        "FR": "Nous avons remarqué que vous avez obtenu le score le plus élevé pour l'énoncé suivant",
        "ES": "Hemos notado que calificaste la siguiente afirmación entre las más altas en general"
    },
    "min_feedback1": {
        "EN": "You scored a",
        "FR": "Vous avez obtenu un",
        "ES": "La has calificado como"
    },
    "min_feedback2": {
        "EN": "Can you provide specific examples of how this factor has impacted you or your colleagues?",
        "FR": "Pouvez-vous fournir des exemples spécifiques de la façon dont ce facteur a impacté vous ou vos collègues?",
        "ES": "¿Puedes proporcionar ejemplos específicos de cómo este factor te ha afectado a ti o a tus colegas?"
    },
    "min_feedback3":{
        "EN":"Please provide an example of why.",
        "FR":"Veuillez fournir un exemple pour expliquer pourquoi.",
        "ES":"Por favor proporciona un ejemplo de por qué."
    },
    "max_feedback1": {
        "EN": "We'd love to know more! Please provide an example of why.",
        "FR": "Nous aimerions en savoir plus! Veuillez fournir un exemple pour expliquer pourquoi.",
        "ES": "¡Nos encantaría saber más! Por favor proporciona un ejemplo de por qué."
    },
    "textarea": {
        "EN": "Type your answer here",
        "FR": "Tapez votre réponse ici",
        "ES": "Escribe tu respuesta aquí"
    },
    "Skip": {
        "EN": "Skip",
        "FR": "Passer",
        "ES": "Omitir"
    },
    'welcomeMessage': {
        'EN': 'We understand that your time is precious, but we\'d like to take a moment to emphasize how important your feedback is to us. Your thoughts and insights can make a world of difference!',
        'FR': 'Nous comprenons que votre temps est précieux, mais nous aimerions prendre un moment pour souligner à quel point vos retours sont importants pour nous. Vos pensées et insights peuvent faire toute la différence !',
        'ES': 'Entendemos que tu tiempo es precioso, pero nos gustaría tomar un momento para enfatizar cuán importante es tu feedback para nosotros. ¡Tus pensamientos y percepciones pueden marcar una gran diferencia!'
    },
    'driveChangeTitle': {
        'EN': 'Drive meaningful change',
        'FR': 'Provoquer un changement significatif',
        'ES': 'Impulsar un cambio significativo'
    },
    'driveChangeText': {
        'EN': 'Your feedback pinpoints areas for improvement, enabling us to prioritize and implement impactful changes.',
        'FR': 'Vos retours identifient les domaines à améliorer, nous permettant de prioriser et mettre en œuvre des changements significatifs.',
        'ES': 'Tu feedback identifica áreas para mejorar, permitiéndonos priorizar e implementar cambios significativos.'
    },
    'reinforceStrengthsTitle': {
        'EN': 'Reinforce our strengths',
        'FR': 'Renforcer nos points forts',
        'ES': 'Reforzar nuestras fortalezas'
    },
    'reinforceStrengthsText': {
        'EN': 'Your positive feedback helps us maintain and enhance the features that resonate with you, ensuring exceptional services.',
        'FR': 'Vos retours positifs nous aident à maintenir et améliorer les fonctionnalités qui vous parlent, assurant des services exceptionnels.',
        'ES': 'Tu feedback positivo nos ayuda a mantener y mejorar las características que resuenan contigo, asegurando servicios excepcionales.'
    },
    'influenceDecisionsTitle': {
        'EN': 'Influence strategic decisions',
        'FR': 'Influencer les décisions stratégiques',
        'ES': 'Influir en las decisiones estratégicas'
    },
    'influenceDecisionsText': {
        'EN': 'Your input informs our decision-making process, leading to a more responsive and user-focused organization.',
        'FR': 'Vos contributions éclairent notre processus décisionnel, menant à une organisation plus réactive et centrée sur l\'utilisateur.',
        'ES': 'Tu aporte informa nuestro proceso de toma de decisiones, llevando a una organización más receptiva y centrada en el usuario.'
    },
    "Leave feedback": {
        "EN": "Leave feedback",
        "FR": "Laisser un commentaire",
        "ES": "Dejar feedback"
    },
    "Skip anyway": {
        "EN": "Skip anyway",
        "FR": "Passer quand même",
        "ES": "Omitir de todos modos"
    },
    "sharing": {
        "EN": "By sharing your experiences, you help us:",
        "FR": "En partageant vos expériences, vous nous aidez à :",
        "ES": "Al compartir tus experiencias, nos ayudas a:"
    },
    "matters": {
        "EN": "Your Feedback Matters!",
        "FR": "Vos retours sont importants !",
        "ES": "¡Tu Feedback Importa!"
    },
    "Very Poor": {
        "EN": "Very Poor",
        "FR": "Très mauvais",
        "ES": "Muy Malo"
    },
    "Excellent": {
        "EN": "Excellent",
        "FR": "Excellent",
        "ES": "Excelente"
    },
    "Congratulations": {
        "EN": "You're almost done!",
        "FR": "Vous avez presque terminé !",
        "ES": "¡Casi has terminado!"
    },
    "Value": {
        "EN": "Your valuable insights matter to us. Go ahead and hit that",
        "FR": "Vos précieux retours nous importent. Allez-y et appuyez sur",
        "ES": "Tu percepcion es valiosa e importante para nosotros. Presiona el botón"
    },
    "Value2": {
        "EN": "button to share your thoughts and help shape our organization’s future.",
        "FR": "bouton pour partager vos pensées et aider à façonner l'avenir de notre organisation.",
        "ES": "para compartir tus pensamientos y ayudar a construir el futuro de nuestra organización."
    },
    "Feedback": {
        "EN": "Feedback",
        "FR": "Commentaire",
        "ES": "Feedback"
    },
    "category_completed":{
        "EN":"Thank you for answering these preliminary questions.",
        "FR":"Merci d'avoir répondu à ces questions préliminaires.",
        "ES":"Gracias por responder a estas preguntas preliminares."
    },
    "category_completed2":{
        "EN":"Now we are going to ask you some questions about your experience with {organizationName}. Your perspectives are important.",
        "FR":"Maintenant, nous allons vous poser quelques questions sur votre expérience avec {organizationName}. Vos perspectives sont importantes.",
        "ES":"Ahora vamos a hacerte algunas preguntas sobre tu experiencia con {organizationName}. Tus perspectivas son importantes."
    },
    "Searching":{
        "EN":"Looking for an existing response",
        "FR":"Recherche d'une réponse existante",
        "ES":"Buscando una respuesta existente"
    },
    "Searching2":{
        "EN":"It looks like we've found an existing survey response. Would you like to:",
        "FR":"Il semble que nous ayons trouvé une réponse à l'enquête existante. Souhaitez-vous :",
        "ES":"Parece que hemos encontrado una respuesta existente a la encuesta. ¿Te gustaría:"
    },
    'Restart':{
        "EN":'Restart the survey',
        "FR":'Redémarrer l\'enquête',
        "ES":'Reiniciar la encuesta'
    },
    "Load":{
        "EN":"Load the existing response",
        "FR":"Charger la réponse existante",
        "ES":"Cargar la respuesta existente"
    },
    "completed_on":{
        "EN":"This survey was completed on",
        "FR":"Cette enquête a été complétée le",
        "ES":"Esta encuesta fue completada el"
    },
    "survey_status1":{
        "EN":"We are unable to get information about this survey.",
        "FR":"Nous ne pouvons pas obtenir d'informations sur cette enquête.",
        "ES":"No podemos obtener información sobre esta encuesta."
    },
    "team_qualifier":{
        "EN":"In {team}'s culture...",
        "FR":"Dans la culture de {team}...",
        "ES":"En la cultura de {team}..."
    },
    "In the hockey environment (training and competition)...":{
        "EN":"In the hockey environment (training and competition)...",
        "FR":"Dans l'environnement du hockey (entraînement et compétition)...",
        "ES":"En el entorno del hockey (entrenamiento y competencia)..."
    },
    "intro4-2":{
        "EN":"DISCLAIMER: This survey uses conversational AI at times to ask more specifically about your experiences. If you are uncomfortable with any AI prompt and do not want to respond, please just hit the skip button. Thank you.",
        "FR":"AVERTISSEMENT : Cette enquête utilise l'IA conversationnelle parfois pour demander plus spécifiquement sur vos expériences. Si vous n'êtes pas à l'aise avec une invite d'IA et ne souhaitez pas répondre, appuyez simplement sur le bouton Ignorer. Merci.",
    },
    
}